import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { X } from '@finect/tabular-icons/x';
import { Edit } from '@finect/tabular-icons/edit';
import { Tooltip } from '../../../Tooltip';
import { Circle } from '../partials/ControlButton/partials';
import { Inner, Name, DeleteContainer, EditContainer } from './partials';
export var CellFund = function CellFund(_ref) {
  var getSheetPath = _ref.getSheetPath,
    productType = _ref.productType,
    fund = _ref.fund,
    index = _ref.index,
    onDeleteAction = _ref.onDeleteAction,
    onChangeClass = _ref.onChangeClass,
    _ref$minimal = _ref.minimal,
    minimal = _ref$minimal === void 0 ? false : _ref$minimal;
  if (minimal) {
    return React.createElement(Inner, null, React.createElement(Name, null, fund.class && fund.class.name ? fund.class.name : fund.name));
  }
  var isUniqueClass = fund.classes && fund.classes.length === 1;
  return React.createElement(Inner, null, onChangeClass && !isUniqueClass && React.createElement(Tooltip, {
    tip: "Cambiar clase",
    from: "left",
    parentAbsolute: true
  }, React.createElement(EditContainer, {
    onClick: onChangeClass
  }, React.createElement(Edit, {
    size: "20"
  }), React.createElement("span", null, "Clase"))), onDeleteAction ? React.createElement(DeleteContainer, {
    onClick: onDeleteAction
  }, React.createElement(X, null)) : null, React.createElement(Name, null, React.createElement(AppLink, {
    key: "fund-name",
    href: getSheetPath && getSheetPath(productType, fund)
  }, fund.class && fund.class.name ? fund.class.name : fund.name)), React.createElement("div", null, React.createElement(Circle, {
    horizontal: true,
    radius: 6,
    index: index
  })));
};